import React, { useState, useEffect } from 'react';
import Faq from './Faq';
import './captcha.css'
function Contact1() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

    // CAPTCHA state
    const [captchaText, setCaptchaText] = useState('');
    const [userInput, setUserInput] = useState('');
    const [error, setError] = useState('');
    const [isVerified, setIsVerified] = useState(false);
  
    // Generate random CAPTCHA text
    const generateCaptcha = () => {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
      let result = '';
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      setCaptchaText(result);
      setUserInput('');
      setIsVerified(false);
    };
  
    // Initialize CAPTCHA on component mount
    useEffect(() => {
      generateCaptcha();
    }, []);
  
    // Handle form input changes
  
  
    // Handle CAPTCHA verification
    const verifyCaptcha = () => {
      if (userInput === captchaText) {
        setIsVerified(true);
        setError('');
        return true;
      } else {
        setError('CAPTCHA text does not match. Please try again.');
        generateCaptcha();
        setIsVerified(false);
        return false;
      }
    };
  
    // Handle form submission
    const handleSubmit = (e) => {
      e.preventDefault();
      
      if (!verifyCaptcha()) {
        return;
      }
  
      // Form is valid and CAPTCHA verified
      alert(`Form submitted successfully!\nFirstname: ${formData.firstName}\nLastname: ${formData.lastName} \nEmail: ${formData.email} \nPhone: ${formData.phone} \nMessage: ${formData.message}`);
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone:'',
        message: ''
      });
      generateCaptcha();
    };

  return (
    <div className="bg-light">
      {/* Hero Section with Background Image */}
      <section className="position-relative text-white d-flex align-items-center justify-content-center" style={{ minHeight: '40vh' }}>
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"></div>
        <div className="position-absolute top-0 start-0 w-100 h-100" 
             style={{ 
               backgroundImage: "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')", 
               backgroundSize: 'cover', 
               backgroundPosition: 'center',
               filter: 'brightness(0.6)'
             }}>
        </div>
        <div className="container position-relative text-center py-5">
          <h1 className="display-4 fw-bold mb-3">Contact Us</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item"><a href="/" className="text-white text-decoration-none">Home</a></li>
              <li className="breadcrumb-item active text-white-50" aria-current="page">Contact Us</li>
            </ol>
          </nav>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-3 hover-shadow transition-300">
                <div className="card-body text-center p-4">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-telephone text-primary" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                    </svg>
                  </div>
                  <h5 className="fw-bold mb-3">Call Us</h5>
                  <p className="text-muted mb-1"><a href="#" className="text-decoration-none text-muted">17795960</a></p>
                  <p className="text-muted mb-0"><a href="#" className="text-decoration-none text-muted">+973 66711158</a></p>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-3 hover-shadow transition-300">
                <div className="card-body text-center p-4">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-geo-alt text-primary" viewBox="0 0 16 16">
                      <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                      <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                    </svg>
                  </div>
                  <h5 className="fw-bold mb-3">Our Location</h5>
                  <p className="text-muted mb-0">Office 0 , Building 51A, Road 10, Block 704, Salmabad, Bahrain</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-3 hover-shadow transition-300">
                <div className="card-body text-center p-4">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-envelope text-primary" viewBox="0 0 16 16">
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                    </svg>
                  </div>
                  <h5 className="fw-bold mb-3">Email Us</h5>
                  <p className="text-muted mb-1"><a href="mailto:sales@zartecsolutions.com" className="text-decoration-none text-muted">sales@zartecsolutions.com</a></p>
                  <p className="text-muted mb-0"><a href="mailto:marketing@zartecsolutions.com" className="text-decoration-none text-muted">marketing@zartecsolutions.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form and Map Section */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="row">
            <div className="col-lg-6 pe-lg-5 mb-5 mb-lg-0" style={{fontFamily:"Poppins"}}>
              <h2 className="fw-bold mb-2">Get In Touch</h2>
              <p className="text-muted mb-3">Fill out the form below, and our team will get back to you as soon as possible.</p>
              
              <form onSubmit={handleSubmit} className="needs-validation">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating mb-2">
                      <input 
                        type="text" 
                        className="form-control" 
                        id="firstName" 
                        name="firstName"
                        placeholder="Your First Name" 
                        value={formData.firstName} 
                        onChange={handleChange}
                        required 
                      />
                      <label htmlFor="firstName">First Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating mb-3">
                      <input 
                        type="text" 
                        className="form-control" 
                        id="lastName" 
                        name="lastName"
                        placeholder="Your Last Name" 
                        value={formData.lastName} 
                        onChange={handleChange}
                        required 
                      />
                      <label htmlFor="lastName">Last Name</label>
                    </div>
                  </div>
                </div>
                
                <div className="form-floating mb-3">
                  <input 
                    type="email" 
                    className="form-control" 
                    id="email" 
                    name="email"
                    placeholder="name@example.com" 
                    value={formData.email} 
                    onChange={handleChange}
                    required 
                  />
                  <label htmlFor="email">Email Address</label>
                </div>
                
                <div className="form-floating mb-3">
                  <input 
                    type="tel" 
                    className="form-control" 
                    id="phone" 
                    name="phone"
                    placeholder="Your Phone Number" 
                    value={formData.phone} 
                    onChange={handleChange}
                  />
                  <label htmlFor="phone">Phone Number (optional)</label>
                </div>
                
                <div className="form-floating mb-4">
                  <textarea 
                    className="form-control" 
                    id="message" 
                    name="message"
                    placeholder="Your Message" 
                    style={{ height: '140px' }}
                    value={formData.message} 
                    onChange={handleChange}
                    required
                  ></textarea>
                  <label htmlFor="message">Your Message</label>
                </div>

                <div className="captcha-group">
          <div className="captcha-display">
            <label>CAPTCHA:</label>
            <div className="captcha-text">{captchaText}</div>
            <button 
              type="button" 
              onClick={generateCaptcha}
              className="refresh-btn"
              aria-label="Refresh CAPTCHA"
            >
              ↻
            </button>
          </div>
          
          <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="Type the text above"
            required
          />
          
          {error && <div className="error-message">{error}</div>}
        </div>
                <div className='my-3'>
                  <button type="submit" className="btn btn-primary btn-lg px-4 py-2">
                  Send Message
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send ms-2" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>
                  </svg>
                </button>

                </div>
                
              </form>
            </div>
            
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-0">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.6314045205954!2d50.521010974396724!3d26.17613119135835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49aff270b9818b%3A0x3cfb8a4983741548!2sZartec%20Solutions!5e0!3m2!1sen!2sbh!4v1740993207912!5m2!1sen!2sbh" 
                    className="w-100 h-100"
                    style={{ minHeight: '450px', border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Google Maps Location">
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <Faq />
      </section>
      
      {/* FAQ Section (Optional) */}
      {/* <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
            <p className="text-muted">Find answers to common questions about our services</p>
          </div>
          
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="accordion" id="contactFAQ">
                <div className="accordion-item border-0 shadow-sm mb-3 rounded">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      What services do you offer?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#contactFAQ">
                    <div className="accordion-body">
                      We offer a comprehensive range of IT solutions including software development, cloud services, cybersecurity, and digital transformation consulting tailored to meet your business needs.
                    </div>
                  </div>
                </div>
                
                <div className="accordion-item border-0 shadow-sm mb-3 rounded">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      How quickly do you respond to inquiries?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#contactFAQ">
                    <div className="accordion-body">
                      We typically respond to all inquiries within 24 business hours. For urgent matters, we recommend calling our support line for immediate assistance.
                    </div>
                  </div>
                </div>
                
                <div className="accordion-item border-0 shadow-sm rounded">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Do you offer support for existing systems?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#contactFAQ">
                    <div className="accordion-body">
                      Yes, we provide comprehensive support and maintenance services for both systems we've developed and existing third-party solutions. Our team specializes in optimizing performance and ensuring business continuity.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Add some custom CSS for hover effects */}
      <style jsx>{`
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
        }
        
        .transition-300 {
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
}

export default Contact1;